import { nullableInput } from '@/features/form/utils/nullableInput'
import {
    FormAddressKeys,
    FormKeys,
    FormPhoneKeys,
} from '@/features/pos/components/CustomerProfile/form/constants/keys'
import parsePhoneNumber from 'libphonenumber-js'
import { z } from 'zod/v4'

const phone = z
    .object({
        [FormPhoneKeys.Flag]: z.string(),
        [FormPhoneKeys.DialCode]: z.string(),
        [FormPhoneKeys.Number]: z
            .string()
            .nonempty({ error: 'form.requiredFieldError', abort: true }),
    })
    .refine((phone) => {
        const phoneNumber = parsePhoneNumber(phone.dialCode + phone.number, { extract: false })

        return phoneNumber?.isPossible()
    }, 'pos.customerProfile.formField.phone.invalid')

const address = z.object({
    [FormAddressKeys.Address]: z.string().nonempty('form.requiredFieldError'),
    [FormAddressKeys.Coordinates]: nullableInput(
        z.object({ latitude: z.number(), longitude: z.number() })
    ),
    [FormAddressKeys.Zone]: nullableInput(z.string()),
    [FormAddressKeys.isValid]: nullableInput(
        z.literal<boolean>(true, {
            error: () => ({
                message: 'pos.customerProfile.formField.address.availability.unavailable',
            }),
        }),
        'pos.customerProfile.formField.address.availability.notValidated'
    ),
})

export const deliverySchema = z.object({
    [FormKeys.Phone]: phone,
    [FormKeys.Name]: z.string(),
    [FormKeys.Address]: address,
})

export const nonDeliverySchema = z.object({
    [FormKeys.Phone]: phone,
    [FormKeys.Name]: z.string(),
})
